import { render, staticRenderFns } from "./document-card.component.vue?vue&type=template&id=906d81f8&"
import script from "./document-card.component.vue?vue&type=script&lang=ts&"
export * from "./document-card.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports